module.exports = __webpack_public_path__ + "static/media/assertify.332a8762.png";